module.exports = __webpack_public_path__ + "static/media/12.75394fc9.webp";